export const scrobbleFmRoot = "https://cacfd3a.github.io/scrobble-fm/";
export const scrobbleApi = `${scrobbleFmRoot}api/`;
export const scrobble2_0 = "https://us-central1-scrobble-fm.cloudfunctions.net/v2_0/";